import React, { useEffect, useState } from 'react'
import { getAllVisibleBanners } from '../../services/public/public.service';
import Slider from 'react-slick';
import { ReactComponent as LeftSlideIcon } from '../../assets/icons/LeftVector.svg';
import { ReactComponent as RightSlideIcon } from '../../assets/icons/RightVector.svg'
import { useHistory } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';


const LEARNING_CENTER_TAB = ['courses', 'video', 'workshops', 'guides']

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <button className='w-8 h-8 inline-flex items-center justify-center bg-[#D0D5DD] rounded-full hover:bg-[#5c5f70]' >
                <RightSlideIcon />
            </button>

        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <button className='w-8 h-8 inline-flex items-center justify-center bg-[#D0D5DD] rounded-full hover:bg-[#5c5f70]' >
                <LeftSlideIcon />
            </button>

        </div>
    );
}

const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 1.20,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

};

const Banner = () => {
    const [banners, setBanners] = useState([]);

    const history = useHistory();

    const getActiveBanners = async () => {
        const res = await getAllVisibleBanners()
        if (res.data.status === 200) {
            setBanners(res.data.data)
        }
    }

    useEffect(() => {
        getActiveBanners()
    }, []);


    return (
        <>
            <div className='w-full !h-full overflow-hidden'>

                <OwlCarousel
                    className='owl-theme rounded-md'
                    dots={false}
                    autoplay={true}
                    loop={true}
                    center={true}
                    autoWidth={true}
                    nav={true}
                    autoplayTimeout={6000}
                    autoplaySpeed={2000}
                    // navText={[`<img src=${LeftSVGIcon} />`, `<img src=${RightSVGIcon} />`]}
                    margin={10}
                    responsive={{
                        0: {
                            items: 1,
                            nav: true,
                            margin: 0

                        },
                        600: {
                            items: 1,
                            nav: true
                        },
                        900: {
                            items: 1.41,
                            nav: true
                        },
                        1000: {
                            items: 1.41,
                            nav: true
                        },
                        1200: {
                            items: 1.4,
                            loop: true,
                            nav: true,
                            margin: 32

                        }
                    }
                    }
                >
                    {
                        banners.map((banner, index) => (
                            <div

                                onClick={() => {
                                    if (LEARNING_CENTER_TAB.includes(banner.redirect_to)) {
                                        history.push(`/learning-center?tab=${banner.redirect_to}`)
                                    } else {
                                        history.push(`/${banner.redirect_to}`)
                                    }
                                }}
                                key={banner.uuid}
                            >
                                <div className='w-[1200px]'>
                                    <img src={banner.web_image_url} alt="" className='h-[400px] !w-full rounded-xl object-cover' />
                                </div>
                            </div>
                        ))
                    }

                </OwlCarousel>

            </div >

            {/* <Slider {...settings}>
                {
                    banners.map((banner, index) => (
                        <div

                            onClick={() => {
                                if (LEARNING_CENTER_TAB.includes(banner.redirect_to)) {
                                    history.push(`/learning-center?tab=${banner.redirect_to}`)
                                } else {
                                    history.push(`/${banner.redirect_to}`)
                                }
                            }}
                            key={banner.uuid}
                        >
                            <div className='!w-full !mr-4'>
                                <img src={banner.web_image_url} alt="" className='h-[400px] !w-full rounded-xl object-cover' />
                            </div>
                        </div>
                    ))
                }
            </Slider> */}
        </>
    )
}

export default Banner